if (typeof window !== typeof undefined) {
    window.fbAsyncInit = function() {
        FB.init({
            appId            : '338556496294669',
            autoLogAppEvents : true,
            xfbml            : true,
            version          : 'v2.8'
        });
    };

    (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/pt_BR/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
}
